module.exports = "<div style=\"border: 1px solid red\">finance-management-list Component</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/finance-management/finance-management-list/finance-management-list.component.html
// module id = ./src/app/finance-management/finance-management-list/finance-management-list.component.html
// module chunks = main